import MainLayoutStyled from './MainLayout.styled'

const MainLayout = (props: any) => <MainLayoutStyled {...props} />
export default MainLayout
